<div class="w-100 d-flex flex-wrap">
  <img
    class="w-100"
    [src]="bannerUrl()"
    alt="diposit-banner"
  />

  <div class="w-100 px-medium">
    <div class="stepper">
      @for (item of stepItems; track $index) {
        <div class="step">
          <div class="circle"></div>
          <div
            class="c-2 text-onback-medium text-align-justify"
            [innerHTML]="item"
          ></div>
        </div>
      }
    </div>
  </div>

  <div class="w-100 d-flex justify-content-center mt-plus mb-large">
    <ngx-icon
      [name]="'headphone'"
      [type]="'bold'"
      [iconSize]="'20px'"
    />

    <a [href]="'tel:' + supportNumber()">
      <span class="c-2 text-onback-medium mr-tiny">
        پشتیبانی

        <span dir="ltr">
          {{ supportNumber() }}
        </span>
      </span>
    </a>
  </div>
</div>
